import { addRelicAnalyticsPageAction, getRelicGeolocation, getRelicUserType, RELIC_EVENT_NAME, } from '@nike/privacy-shared-logic';
export const fetchClient = async ({ request, isLoggedIn, memberLocation, }) => {
    const errorOptions = {
        url: request.url,
        status: null,
        body: null,
    };
    try {
        const response = await fetch(request);
        if (response.status >= 400) {
            errorOptions.body = await response.text();
            errorOptions.status = response.status;
            throw new Error(`status: ${response.status} message: ${response.statusText}`);
        }
        return response;
    }
    catch (e) {
        const { status, url, body } = errorOptions;
        addRelicAnalyticsPageAction(RELIC_EVENT_NAME.PRIVACY_CORE_API_ERROR, {
            user_type: getRelicUserType(isLoggedIn),
            consent: '',
            geolocation: getRelicGeolocation(),
            error_message: `${e}`,
            api_url: url,
            ...(status && { status_code: `${status}` }),
            ...(body && { response_body: body }),
            ...(memberLocation && { registered_country: memberLocation }),
        });
        return Promise.reject(e);
    }
};
